module.exports = __webpack_public_path__ + "img/aderhold-hall.f80d2979.jpg";